module.exports = __webpack_public_path__ + "img/kommune-1511.8a4128a2.svg";